var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThickPlus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.375,
    height: 11.375,
    viewBox: "0 0 11.375 11.375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    "data-name": "Path 415",
    d: "M5.688-5.25a.655.655,0,0,1-.656.656H.656V-.219A.657.657,0,0,1,0,.438.656.656,0,0,1-.656-.219V-4.594H-5.031a.656.656,0,0,1-.656-.656.657.657,0,0,1,.656-.657H-.656v-4.375A.656.656,0,0,1,0-10.937a.656.656,0,0,1,.656.656v4.375H5.031A.656.656,0,0,1,5.688-5.25Z",
    transform: "translate(5.688 10.937)",
    fill: "#fefeff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThickPlus);
export default __webpack_public_path__ + "static/media/thick_plus.3ee1356496b3655da8e39982e89ee037.svg";
export { ForwardRef as ReactComponent };